import { FC } from 'react';
import { PageTitle, PageLink } from '../../../../rbts/layout/core';
import { Vista } from './components/Vistas';

const ConsultarMovimientos: FC = () => {
  const widgetsBreadCrumbs: Array<PageLink> = [];

  return (
    <>
      <PageTitle
        breadcrumbs={widgetsBreadCrumbs}
      >{`${'Consultar movimientos por ticket'}`}</PageTitle>
      <Vista />
    </>
  );
};

export { ConsultarMovimientos };
